<template>
    <div class="col-md-6">
        <div class="panel panel-default">
            <div class="panel-heading">
                {{trans_heading}}
                <select name="costCarrierChartMonth" id="costCarrierChartMonth" class="pull-right" v-model="selectedMonth">
                    <option :value="index" v-for="(month, index) in months">{{month}}</option>
                </select>
            </div>
            <div class="panel-body">
                <plot :id="plotId" :ref="plotId" :options="options" :type="type"></plot>
            </div>
        </div>
    </div>
</template>

<script>
  import axios from 'axios';
  import Plot from './Plot';

  export default {
    components: {'Plot': Plot},
    data() {
      return {
        trans_heading: Worklog.costCarrierMonthChart.trans_heading,
        months       : Worklog.costCarrierMonthChart.months,
        selectedMonth: Worklog.costCarrierMonthChart.lastMonth,
        url          : Worklog.costCarrierMonthChart.url,
        plotId       : 'costCarrierChart',
        type         : 'doughnut',
        options      : {
          legend: {
            position: 'right',
            labels  : {
              boxWidth: 30,
            }
          }
        },
      }
    },
    watch     : {
      selectedMonth: function (val) {
        this.fetchData();
      },
    },
    mounted() {
      this.$refs[ this.plotId ].updateChart(Worklog.costCarrierMonthChart.data);
    },
    methods   : {
      fetchData() {
        axios.get(this.url.replace(':month', this.selectedMonth))
          .then(response => {
            response.data && this.$refs[ this.plotId ].updateChart(response.data);
          })
          .catch(e => {
            this.$refs[ this.plotId ].updateChart({
              dataSets: [],
              labels  : []
            });
          })
      }
    }
  }
</script>
